export const BASE_URL = process.env.REACT_APP_API_URL
export const emailFormat = /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/

// Seller
export const loginPath = '/login'
export const landingPath='/codes'
export const defaultRole = 'SELLER'